import { useSearchParams } from "react-router-dom";

/** Onglet actif d'un `Tabs` en mode URL (search param `tab-${id}`). */
export default function useActiveTab(id: string, defaultValue: string) {
  const [params] = useSearchParams();
  return params.get(`tab-${id}`) ?? defaultValue;
}
